// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.login-container {
    /* background-color: #F0F2F5; */
    width: 329px;
    border-radius: 33px;
    height: 59px;
    /* justify-content: space-around; */
    align-items: center;
    display: flex;
}
.login-container-btn {
    width: 146px;
    border-radius: 33px;
}

.btn-link {
    color: #006644;
    text-decoration: none;
}
.btn-link:hover {
    color: #006644;
    text-decoration: none;
}
.onboard-title {
    color: #001A11;
    font-size: 30px;
    font-weight: 600;
    margin-bottom: 60px;
    text-align: center;
}
.customer-onborad-header {
    width: 40%;
    display: inline-block;
    justify-content: center;
    display: flex;
    flex-direction: column;
    align-items: center;
}
.signin-signup-container {
    justify-content: flex-end;
    display: inline-block;
    width: 60%;
    margin-top: 20px;
    /* max-width: 450px; */
}
.container {
    display: flex;
    flex-direction: row;
    /* width: 100%; */
    margin-top: 30px;
    justify-content: space-around;
}
.signin-text-box {
    width: 360px;
    height: 40px;
    border-radius: 5px;
    border: 1px solid #ACACAC;
    box-sizing: border-box;
}
.signin-input-box {
    border-radius: 10px;
}
.signin-input-box:hover {
    border-color: #006644 !important;
}
.signin-input-box:focus {
    border-color: #006644 !important;
}
.login-content {
    max-width: 350px;
    margin-left: 30%;
}
.login-grid-item {
    padding-bottom: 5px;
    flex-direction: row;
    width: 360px;
}
.login-grid-item-error {
    padding-bottom: 35px;
    flex-direction: row;
}
.payapt-title-container {
    width: 394px;
    height: 108px;
    top: 159px;
    left: 154px;
}
.onboarding-img {
    width: 425px;
    height: 425;
    top: 223px;
    left: 138px;
}
.login-remember{
    font-family: 'Inter';
}
.mui-button-requestotp{
    display: flex;
flex-direction: row;
align-items: center;
padding: 13px 10px;
gap: 8px;

left: -10px;

background: #009966;
border-radius: 5px;
}`, "",{"version":3,"sources":["webpack://./src/components/styles/loginStyles.css"],"names":[],"mappings":"AAAA;IACI,+BAA+B;IAC/B,YAAY;IACZ,mBAAmB;IACnB,YAAY;IACZ,mCAAmC;IACnC,mBAAmB;IACnB,aAAa;AACjB;AACA;IACI,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,qBAAqB;AACzB;AACA;IACI,cAAc;IACd,qBAAqB;AACzB;AACA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;AACtB;AACA;IACI,UAAU;IACV,qBAAqB;IACrB,uBAAuB;IACvB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;AACvB;AACA;IACI,yBAAyB;IACzB,qBAAqB;IACrB,UAAU;IACV,gBAAgB;IAChB,sBAAsB;AAC1B;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,iBAAiB;IACjB,gBAAgB;IAChB,6BAA6B;AACjC;AACA;IACI,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,yBAAyB;IACzB,sBAAsB;AAC1B;AACA;IACI,mBAAmB;AACvB;AACA;IACI,gCAAgC;AACpC;AACA;IACI,gCAAgC;AACpC;AACA;IACI,gBAAgB;IAChB,gBAAgB;AACpB;AACA;IACI,mBAAmB;IACnB,mBAAmB;IACnB,YAAY;AAChB;AACA;IACI,oBAAoB;IACpB,mBAAmB;AACvB;AACA;IACI,YAAY;IACZ,aAAa;IACb,UAAU;IACV,WAAW;AACf;AACA;IACI,YAAY;IACZ,WAAW;IACX,UAAU;IACV,WAAW;AACf;AACA;IACI,oBAAoB;AACxB;AACA;IACI,aAAa;AACjB,mBAAmB;AACnB,mBAAmB;AACnB,kBAAkB;AAClB,QAAQ;;AAER,WAAW;;AAEX,mBAAmB;AACnB,kBAAkB;AAClB","sourcesContent":[".login-container {\n    /* background-color: #F0F2F5; */\n    width: 329px;\n    border-radius: 33px;\n    height: 59px;\n    /* justify-content: space-around; */\n    align-items: center;\n    display: flex;\n}\n.login-container-btn {\n    width: 146px;\n    border-radius: 33px;\n}\n\n.btn-link {\n    color: #006644;\n    text-decoration: none;\n}\n.btn-link:hover {\n    color: #006644;\n    text-decoration: none;\n}\n.onboard-title {\n    color: #001A11;\n    font-size: 30px;\n    font-weight: 600;\n    margin-bottom: 60px;\n    text-align: center;\n}\n.customer-onborad-header {\n    width: 40%;\n    display: inline-block;\n    justify-content: center;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n}\n.signin-signup-container {\n    justify-content: flex-end;\n    display: inline-block;\n    width: 60%;\n    margin-top: 20px;\n    /* max-width: 450px; */\n}\n.container {\n    display: flex;\n    flex-direction: row;\n    /* width: 100%; */\n    margin-top: 30px;\n    justify-content: space-around;\n}\n.signin-text-box {\n    width: 360px;\n    height: 40px;\n    border-radius: 5px;\n    border: 1px solid #ACACAC;\n    box-sizing: border-box;\n}\n.signin-input-box {\n    border-radius: 10px;\n}\n.signin-input-box:hover {\n    border-color: #006644 !important;\n}\n.signin-input-box:focus {\n    border-color: #006644 !important;\n}\n.login-content {\n    max-width: 350px;\n    margin-left: 30%;\n}\n.login-grid-item {\n    padding-bottom: 5px;\n    flex-direction: row;\n    width: 360px;\n}\n.login-grid-item-error {\n    padding-bottom: 35px;\n    flex-direction: row;\n}\n.payapt-title-container {\n    width: 394px;\n    height: 108px;\n    top: 159px;\n    left: 154px;\n}\n.onboarding-img {\n    width: 425px;\n    height: 425;\n    top: 223px;\n    left: 138px;\n}\n.login-remember{\n    font-family: 'Inter';\n}\n.mui-button-requestotp{\n    display: flex;\nflex-direction: row;\nalign-items: center;\npadding: 13px 10px;\ngap: 8px;\n\nleft: -10px;\n\nbackground: #009966;\nborder-radius: 5px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
